import { onMounted, onUnmounted } from "vue";

const FOCUSABLE_SELECTOR = [
  "button:not([disabled])",
  "input:not([disabled])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "a[href]",
  "[tabindex]:not([tabindex='-1'])",
  "[role='button']:not([disabled])",
  "[contenteditable='true']",
].join(", ");

/**
 * Composable for trapping focus within a modal container.
 * @param {() => HTMLElement | null} getContainer - Function that returns the container element
 * @param {() => boolean} isActive - Function that returns whether the trap should be active
 */
export function useFocusTrap(getContainer, isActive) {
  function handleKeydown(event) {
    if (!isActive()) return;
    if (event.key !== "Tab") return;

    const container = getContainer();
    if (!container) return;

    const focusable = container.querySelectorAll(FOCUSABLE_SELECTOR);
    if (focusable.length === 0) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  onMounted(() => document.addEventListener("keydown", handleKeydown));
  onUnmounted(() => document.removeEventListener("keydown", handleKeydown));

  return { handleKeydown };
}
